import {createBase} from "./elements/base";
import {ProductData, ProductElement, ProductElementModifier, ProductElementParamType} from "../../product-types";
import {maxPrintHeight} from "../../../consts";
import {createGrooves} from "./elements/grooves";
import planterImage from '../../../../images/products/doniczka1.svg'
import {RoundBottom} from "../modifiers/round-bottom";
import {Twist} from "../modifiers/twist";
import {Oval} from "../modifiers/oval";
import {createBottom} from "../common/bottom";
import {createText} from "./elements/text";

const roundedBottomModifier: ProductElementModifier = {
    name: 'ROUNDED_BOTTOM',
    function: RoundBottom,
    params: []
};

const twistModifier: ProductElementModifier = {
    name: 'TWIST',
    function: Twist,
    params: [{
        type: ProductElementParamType.HORIZONTAL_RANGE,
        name: 'TWIST_AMOUNT',
        key: 'twistAmount',
        defaultValue: 0,
        step: 0.05,
        minValue: -1,
        valMapper: val => val * 10,
        maxValue: 1
    }]
}

const roundedBaseModifier: ProductElementModifier = {
    name: 'ROUNDED_BASE',
    function: Oval,
    params: [{
        type: ProductElementParamType.HORIZONTAL_RANGE,
        name: 'OVAL_WIDTH',
        key: 'ovalWidth',
        unit: 'cm',
        defaultValue: 0.5,
        step: 0.5,
        minValue: -2,
        valMapper: val => val,
        maxValue: 4
    }]
};

const elements: ProductElement[] = [
    {
        title: 'TYPES.SMOOTH_NO_TEXT',
        generatorFunction: (radius, values) => createBase(radius, values),
        modifiers: [roundedBaseModifier, roundedBottomModifier],
        params: [
            {
                type: ProductElementParamType.HORIZONTAL_RANGE,
                key: 'height',
                name: 'HEIGHT',
                step: 1,
                unit: 'cm',
                defaultValue: 30,
                minValue: 10,
                valMapper: val => val / 10,
                maxValue: maxPrintHeight
            }
        ]
    },
    {
        title: 'TYPES.GROOVY',
        modifiers: [roundedBaseModifier, twistModifier, roundedBottomModifier],
        generatorFunction: (radius, values) => createGrooves(radius, values),
        params: [
            {
                type: ProductElementParamType.HORIZONTAL_RANGE,
                key: 'height',
                name: 'HEIGHT',
                unit: 'cm',
                step: 1,
                defaultValue: 30,
                minValue: 10,
                valMapper: val => val / 10,
                maxValue: maxPrintHeight
            },
            {
                type: ProductElementParamType.HORIZONTAL_RANGE,
                name: 'GROOVE_COUNT',
                key: 'count',
                step: 1,
                defaultValue: 90,
                minValue: 10,
                valMapper: val => val,
                maxValue: 100
            }
        ]
    },
    {
        title: 'TYPES.SMOOTH_TEXT',
        modifiers: [],
        generatorFunction: (radius, values) => createText(radius, values),
        params: [
            {
                type: ProductElementParamType.HORIZONTAL_RANGE,
                key: 'height',
                name: 'HEIGHT',
                step: 1,
                unit: 'cm',
                defaultValue: 30,
                minValue: 10,
                valMapper: val => val / 10,
                maxValue: maxPrintHeight
            },
            {
                type: ProductElementParamType.TEXT,
                key: 'text',
                name: 'TEXT',
                step: 1,
                unit: 'cm',
                defaultValue: "Test text",
                minValue: 10,
                valMapper: val => val / 10,
                maxValue: maxPrintHeight
            }
        ]
    },
]

export const BASE_PLANTER: ProductData = {
    id: 'GROOVY',
    title: 'Groovy Planter',
    state: 'NEW',
    icon: planterImage,
    maxElements: 5,
    elements,
    disabled: false,
    bottomElement: (radius) => createBottom(radius),
    description: "Stwórz przytulny klimat w swoim domu dzięki naszej doniczce w stylu boho. Wykonana z naturalnych, biodegradowalnych materiałów. Doskonale nadaje się do postawienia na balkonie czy altanie. Delikatne, pastelowe kolory – różowy, miętowy i jasnobeżowy – dodadzą Twojemu wnętrzu subtelnego uroku.",
    images: [
        "https://metcon-uploads.s3.eu-central-1.amazonaws.com/shop/1/1.png",
    ],
    details: [
        "Produkt stworzony z materiałów biodegradowalnych.",
        "Doniczki pokryte są warstwą żywicy zapobiegającą przeciekaniu oraz chroniącą przed słońcem.",
        "Tutaj 3 opis."
    ],
    policies: [],
    default: [
        {
            config: elements[0],
            values: {
                height: 40
            },
            modifiers: [],
        },
        {
            config: elements[1],
            values: {
                height: 60,
                count: 90
            },
            modifiers: [],
        },
        {
            config: elements[0],
            values: {
                height: 20
            },
            modifiers: [],
        },
        {
            config: elements[0],
            values: {
                height: 40
            },
            modifiers: [roundedBottomModifier],
        }
    ],
};